export default {
  redirecionar(vue: any, pathParameter: any, dados: any) {
    vue.$router.push({
      name: pathParameter,
      params: {
        hide: true,
        dados,
        redirect: vue.$route.meta.redirect,
      },
      meta: {
        redirect: vue.$route.meta.redirect,
      },
    });
  },

  getRotaDestino(vue: any) {
    let retorno = '';
    if (vue.$route.meta.redirect) {
      retorno = vue.$route.meta.redirect;
    } else if (vue.$route.params.redirect) {
      retorno = vue.$route.params.redirect;
    } else if (vue.$defaultAuthRoutePath) {
      retorno = vue.$defaultAuthRoutePath;
    } else {
      retorno = process.env.VUE_APP_DEFAULT_AUTH_ROUTE;
    }
    const path = vue.$router.resolve({ path: retorno }).resolved;
    if (path) {
      return path.name;
    }
    return '';
  },

  deslogar(vue: any) {
    localStorage.clear();
    this.redirecionar(vue, 'login', null);
  },
};
